module.exports = __webpack_public_path__ + "img/benefit-image.dd04a877.jpg";